import { up } from 'styled-breakpoints';
import styled from 'styled-components';

const ContainerBox = styled.div<{ fullWidthInMobile?: boolean }>`
  min-width: 360px;
  align-self: center;
  width: 100%;
  padding: ${(props) => (props.fullWidthInMobile ? `0` : `0 16px`)};
  ${up('md')} {
    width: 992px;
    padding: 0 16px;
  }
`;

const ContainerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Container = (props: { fullWidthInMobile?: boolean; children: JSX.Element | Array<JSX.Element> }) => {
  return (
    <ContainerWrapper>
      <ContainerBox fullWidthInMobile={props.fullWidthInMobile}>{props.children}</ContainerBox>
    </ContainerWrapper>
  );
};

export default Container;
